import Validator from '../../validator/validator.js';
import Max from './max.js';
import Min from './min.js';
import Is from './is.js';
import InRange from './in.js';

export default angular.module('BaseClass.validatable.validaters.',[Validator, Max, Min, Is, InRange])
    .factory('length', function(BCValidator, max, min, inRange, is) {
        function length() {}
        length.message = 'does not meet the length requirements.';

        length.options = {
            max: max,
            min: min,
            in: inRange,
            is: is
        };

        return new BCValidator(length,'length');
    }).name;
